import { render } from "./DynamicGroupForm.vue?vue&type=template&id=1ac61f9f&scoped=true"
import script from "./DynamicGroupForm.vue?vue&type=script&lang=ts"
export * from "./DynamicGroupForm.vue?vue&type=script&lang=ts"

import "./DynamicGroupForm.vue?vue&type=style&index=0&id=1ac61f9f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ac61f9f"

export default script